export const JustAdded = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66697 2.66699H9.33363L8.85119 6.52655L11.9524 4.17895L13.2858 6.48836L9.70209 8.00032L13.2858 9.51229L11.9524 11.8217L8.85119 9.4741L9.33363 13.3337H6.66697L7.14941 9.47412L4.04818 11.8217L2.71484 9.51229L6.29853 8.00032L2.71484 6.48836L4.04818 4.17896L7.14941 6.52653L6.66697 2.66699Z"
        fill="#261B36"
      />
    </svg>
  );
};
